import React, { useState } from "react";
import MideaViewer from "../../../midea_viewer/MideaViewer";
import { iconData } from "../../../iconData";
import { IP } from "../../../internalServer";
import PdfViewer from "../../PdfViewer/PdfViewer";
import assets from "../../../assets/assets";

function PdfQType({ attachment, attachData }) {

    const [mideaviewer, setMideaviewer] = useState(false);
    const [isClicked, setIsClicked] = useState(false);
    const [responseAttach, setResponseAttach] = useState();
    const [isError, setIsError] = useState(false);
    const attachformat = (para) => {
        const filePath = para;
        const fileName = filePath.split("/").pop();
        const fileNameWithoutId = fileName.split("_")[1];
        return fileNameWithoutId;
    };
    const handleClick = (attachment) => {
        setResponseAttach(attachment);
        setIsClicked(!isClicked);
    };
    const handleClickforpdf = (attachment) => {
        setResponseAttach(attachment);
        setMideaviewer(true);
    };
    return (
        <>
            <div className=" total_pdf m-1 border p-1 rouded-2 ">
                <div
                    className="all_pdf_pre flex cursor-pointer"
                    style={isError ? { pointerEvents: "none", opacity: 0.5 } : {}}
                    onClick={() => {
                        const fileType = attachment.split(".").pop();
                        if (
                            fileType === "jpg" ||
                            fileType === "jpeg" ||
                            fileType === "png" ||
                            fileType === "mp4" ||
                            fileType === "JPG" ||
                            fileType === "JPEG" ||
                            fileType === "PNG" ||
                            fileType === "MP4"
                        ) {
                            handleClick(attachment);
                        } else if (
                            fileType === "pdf" ||
                            fileType === "PDF" ||
                            fileType === "ppt" ||
                            fileType === "PPT" ||
                            fileType === "PPTX" ||
                            fileType === "pptx"
                        ) {
                            handleClickforpdf(attachment);
                        }
                    }}
                >
                    <>
                        {attachment.split(".").pop() === "jpg" ||
                            attachment.split(".").pop() === "jpeg" ||
                            attachment?.split(".").pop() === "JPEG" ||
                            attachment?.split(".").pop() === "JPG" ||
                            attachment?.split(".").pop() === "PNG" ||
                            attachment?.split(".").pop() === "mp4" ||
                            attachment?.split(".").pop() === "MP4" ||
                            attachment.split(".").pop() === "png" ? (
                            <div
                                // key={index}
                                onClick={() => {
                                    if (!isError) {
                                        handleClick(attachment);
                                        console.log("click");
                                    }
                                }}
                                style={isError ? { pointerEvents: "none", opacity: 0.5 } : {}}
                                className="d-flex gap-2 p-1"
                            >
                                <div className="d-flex align-items-center">
                                    <img
                                        src={`${iconData?.find(
                                            (i) => i.extension === attachment?.split(".").pop()
                                        )?.icon
                                            }`}
                                        alt=""
                                        className="w-8"
                                    />
                                </div>
                            </div>
                        ) : attachment.split(".").pop() === "pdf" ? (
                            <div
                                className="d-flex align-items-center"
                                onClick={() => handleClickforpdf(attachment)}
                            >
                                <img
                                    className="w-8"
                                    src={`${iconData?.find(
                                        (i) => i.extension === attachment?.match(/\.([^.]+)$/)[1]
                                    )?.icon
                                        }`}
                                    alt=""
                                />
                            </div>
                        ) : attachment.startsWith("https://") && (<div onClick={() => window.open(attachment, "_blank", "noopener,noreferrer")} className="flex gap-2 items-center">
                            <div className="mb-2">
                                <img
                                    src="/images/link-icon.png"
                                    alt=""
                                    className="w-10"
                                    style={{ width: 40, height: 40 }}
                                />
                            </div>
                            <div className="text-sm font-weight-medium text-center">
                                <div >
                                    {(() => {
                                        const today = new Date();
                                        const day = String(today.getDate()).padStart(2, "0");
                                        const month = String(today.getMonth() + 1).padStart(2, "0");
                                        const year = today.getFullYear();
                                        return `link_${day}-${month}-${year}`;
                                    })()}
                                </div>
                            </div>
                        </div>
                        )}
                    </>
                    {attachment.startsWith("https://") ? null : (<div className="pdf_detail" style={{ marginLeft: "5px" }}>
                        <div className="d-flex align-itens-center justify-content-between">
                            <span className="pdf-txt1">{attachData?.subject_id?.name}</span>
                        </div>
                        <div
                            className="pdf-txt2"
                            title={attachformat(attachment)}
                            style={{
                                textOverflow: "ellipsis",
                                overflow: "hidden",
                                whiteSpace: "nowrap",
                                maxWidth: "100px",
                            }}
                        >
                            {attachformat(attachment)}
                        </div>
                    </div>)}
                </div>
            </div>
            {mideaviewer && (
                <PdfViewer
                    closeMideaviewer={setMideaviewer}
                    attachment={attachment}
                />
            )}
            {isClicked &&
                (responseAttach.split(".").pop() === "mp4" ||
                    responseAttach.split(".").pop() === "MP4" ? (
                    <div className="fullSizeImg ">
                        <div className="SubfullSizeImg">
                            <video className="videoPlayer" controls>
                                <source
                                    src={IP + responseAttach.replace(/^\./, "")}
                                    type="video/mp4"
                                />
                            </video>
                            <div>
                                <img
                                    className="absolute top-[-20px] right-[-25px] cursor-pointer w-7 bg-white rounded-full"
                                    onClick={handleClick}
                                    src={assets.CrossIcon}
                                    alt="cross logo"
                                ></img>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="fullSizeImg ">
                        <div className="SubfullSizeImg">
                            {!isError ? (
                                <>
                                    {/* {console.log("1st")} */}
                                    <img
                                        className="imgMain"
                                        src={IP + responseAttach?.replace(/^\./, "")}
                                        alt="Full-size"
                                        onError={(e) => {
                                            setIsError(true);
                                        }}
                                    />
                                    <div>
                                        <img
                                            className="absolute top-[-20px] right-[-25px] cursor-pointer w-7 bg-white rounded-full"
                                            onClick={handleClick}
                                            src={assets.CrossIcon}
                                            alt="cross logo"
                                        ></img>
                                    </div>
                                </>
                            ) : (
                                <div
                                    className="fullSizeImg"
                                    style={{ display: "flex", flexDirection: "column" }}
                                >
                                    {/* {console.log("2nd")} */}
                                    <img
                                        onClick={() => {
                                            handleClick();
                                            setIsError(false);
                                        }}
                                        src="/images/cross.png"
                                        alt="Up Arrow"
                                        style={{ position: "absolute", top: "75px", right: "40%" }}
                                    />
                                    <img
                                        src="/images/no-photo-1.png"
                                        alt="img"
                                        style={{ width: "25%" }}
                                    />
                                    <p
                                        style={{
                                            color: "red",
                                            fontSize: "20px",
                                            fontWeight: "500",
                                            marginRight: "35px",
                                        }}
                                    >
                                        Error!! failed to load the requested file!
                                    </p>
                                </div>
                            )}
                        </div>
                    </div>
                ))}
        </>
    )
}

export default PdfQType;
